var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyBch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136700)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1516_136700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
    fill: "#0AC18E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5269 9.07208C17.8234 7.47665 16.2066 7.13553 14.2274 7.46599L13.5914 5L12.0919 5.38731L12.7173 7.84619C12.3228 7.94569 11.9178 8.03096 11.5162 8.14467L10.8909 5.7L9.39137 6.08731L10.0274 8.5533C9.70406 8.64569 7 9.33858 7 9.33858L7.41218 10.9447C7.41218 10.9447 8.51371 10.6355 8.50305 10.6604C9.11421 10.5005 9.40203 10.8061 9.53706 11.0939L11.2853 17.8523C11.3066 18.0477 11.2711 18.3817 10.8518 18.4954C10.8766 18.5096 9.76091 18.7761 9.76091 18.7761L9.92437 20.6487C9.92437 20.6487 12.6036 19.9629 12.9553 19.8741L13.5985 22.3685L15.098 21.9812L14.4548 19.469C14.867 19.3731 15.2685 19.2736 15.6594 19.1706L16.299 21.6685L17.7985 21.2812L17.1553 18.7904C19.465 18.2289 21.0959 16.7721 20.7619 14.5442C20.5487 13.201 19.0812 12.0995 17.8624 11.9751C18.6122 11.3107 18.9924 10.3406 18.5269 9.07208ZM17.8056 14.9528C18.1041 17.1594 15.0376 17.4294 14.0249 17.6959L13.1437 14.3949C14.1599 14.1284 17.301 13.0091 17.8056 14.9528ZM15.9579 10.4579C16.2741 12.4193 13.6518 12.6467 12.8061 12.8635L12.003 9.86802C12.8523 9.65838 15.3147 8.64213 15.9579 10.4579Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1516_136700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyBch);
export default __webpack_public_path__ + "static/media/Currency=BCH.e9012fcd64d427b20abf62691feb10f5.svg";
export { ForwardRef as ReactComponent };